<!-- src/App.vue -->

<template>
  <main>
    <div class="container mx-auto" data-aos="fade-right">
      <div class="row justify-content-center mt-3 m-2 dark-gray-box-1 p-4">
        <div class="col-12 col-md-6 py-2 mb-3 mb-lg-0 text-align-center">
          <img src="https://r4.sinlessproject.com/media/Assets/candlelight.gif" alt="Distorted Lime Goat skull" class="img-fluid mb-3 vibrantlimeborder">
            <h1 class="MainTitleFont textmain">I'll still be here</h1>
              <p class="textwhite">
                For support, bug reports or suggestions
                <br><a href="mailto:support@sinlessstudios.com" class="textsecondary fontSize16 textmainglow">support@sinlessstudios.com</a>
              </p>
              <p class="textwhite">
              For business inquiries
              <br><a href="mailto:business@sinlessstudios.com" class="textsecondary fontSize16 textmainglow">business@sinlessstudios.com</a>
              </p>
          </div>
      </div>
    </div>
  </main>
</template>

<style scoped>
.vibrantlimeborder {
  border-top: 2px solid #00c500;
  border-bottom: 2px solid #007100;
  border-left: 2px solid #00c500;
  border-right: 2px solid #005b00;
  border-radius: 5px;
}
</style>

<script>
  //import imageBlock from './../../components/imageBlock.vue';
  //import HomePagePart1ArtistsNews from '@/HomePagePart1ArtistsNews.vue';
  import 'animate.css';
  
  export default {
    name: 'HomePage',
    components: {
    //imageBlock,
    //HomePagePart1ArtistsNews,
   
    },
    // Hide the data until user selects it
    data() {
      return {
        showApp: true,
        showB1:  false,
        showB2:  false,
        showB3:  false,
        showB4:  false,
        showB5:  false,
        isClassAdded: false,
        apiUrl: '',
      };
    },
    methods: {
      toggle(property) {
        console.log('Toggling', property);
        this[property] = !this[property];
      },
      addClass(event) {
      // Prevent the default navigation
      event.preventDefault();

      // Add the class to trigger the animation
      this.isClassAdded = true;

      // Wait for the animation to complete before navigating
      // Assuming the animation duration is 1 second (1000 milliseconds)
      setTimeout(() => {
        window.location.href = this.apiUrl;
      }, 1000); // Adjust the timeout duration based on your actual animation duration
    },
    },
    mounted(){
      document.title = "Sinless Project Contact";
    },
    created() {
      const userAgent = navigator.userAgent;
      if (process.env.NODE_ENV === 'production' || (/Mobi|Android/i.test(userAgent))) {
        this.apiUrl = 'https://dev.sinlessproject.com/subTitleFont';
      } else {
        this.apiUrl = 'http://localhost:8080/subTitleFont';
      }

  },
  }

</script>